<form (ngSubmit)="onSubmit()" #form="ngForm" column-classes="col-md-2,col-md-4,col-md-6">
  <cap-content-header [disableBreadcrumb]="true">
    <cap-title>
      {{ titleKey | translate }}
    </cap-title>
    <cap-title-functionbar>
      @if (isReadOnlyMode()) {
        <button (click)="onEdit()" class="btn btn-outline-primary btn-sm me-2" type="button">
          <i class="fas fa-pen me-2"></i>{{ "functionbar.edit" | translate }}
        </button>
      }
      @if (isEditMode() || isNewMode()) {
        <button (click)="onCancel()" class="btn btn-outline-primary btn-sm me-2" type="button">
          <i class="fas fa-times me-2"></i> {{ "functionbar.cancel" | translate }}
        </button>
      }
      @if (isEditMode()) {
        <button (click)="onDelete()" class="btn btn-outline-primary btn-sm me-2" type="button">
          <i class="fas fa-trash me-2"></i>{{ "functionbar.delete" | translate }}
        </button>
      }
      @if (isEditMode() || isNewMode()) {
        <button [disabled]="!form.valid" class="btn btn-primary btn-sm" type="submit">
          <i class="fas fa-check me-2"></i>{{ "functionbar.save" | translate }}
        </button>
      }
    </cap-title-functionbar>
  </cap-content-header>
  <fieldset [disabled]="false">
    @if (writeModel) {
      <div>
        <cap-form-row column-classes="col-md-2,col-md-4">
          <cap-form-control labelKey="configuration.titel">
            <input [(ngModel)]="writeModel.title" [maxLength]="50" appAutofocus name="titel" required type="text" />
          </cap-form-control>
        </cap-form-row>
        <cap-form-row column-classes="col-md-2,col-md-4">
          <cap-form-control labelKey="configuration.deutscherName">
            <input [(ngModel)]="writeModel.linkTextDe" [maxLength]="100" name="linkTextDe" required type="text" />
          </cap-form-control>
          <cap-form-control labelKey="configuration.deutscherLink">
            <input [(ngModel)]="writeModel.linkDe" [maxLength]="255" name="linkDe" required size="50" type="text" />
          </cap-form-control>
        </cap-form-row>
        <cap-form-row column-classes="col-md-2,col-md-4">
          <cap-form-control labelKey="configuration.franzoesischerName">
            <input [(ngModel)]="writeModel.linkTextFr" [maxLength]="100" name="linkTextFr" required type="text" />
          </cap-form-control>
          <cap-form-control labelKey="configuration.franzoesischerLink">
            <input [(ngModel)]="writeModel.linkFr" [maxLength]="255" name="linkFr" required size="50" type="text" />
          </cap-form-control>
        </cap-form-row>
      </div>
    }
  </fieldset>
</form>
